<template>
  <div>
    <v-sheet
      class="image-sheet"
      :style="{ backgroundImage: 'url(' + home_image + ')' }"
      outlined
      min-height="65vh"
      v-if="!this.edition.edition.waiting_room && !loading ">
      <v-row>
        
        <v-col
          cols="12" class="mt-8 pt-8">
          <v-row>
            <v-col cols="12" class="text-center pl-8 pr-8">
              <h1 :class="{'font-weight-light': true, 'black--text': !home_title_dark_mode, 'white--text': home_title_dark_mode}">
                {{ home_title }}
              </h1>
            </v-col>
          </v-row>
        </v-col>

        <v-row v-if="!loading && $vuetify.breakpoint.smAndUp">
          <v-col cols="10" class="mt-8 mx-auto">
            <v-row align="center"> <!-- 👈 clave -->
              <v-col cols="12" xl="6" md="6" sm="12" class="d-flex justify-center">
                <v-img 
                  max-width="410px"
                  max-height="520px"
                  min-height="410px"
                  contain
                  @click="dialog_edition = true"
                  style="cursor: pointer;"
                  :src="home_logo"
                />
              </v-col>

              <v-col 
                class="d-flex justify-center"
                cols="12" 
                xl="6" 
                md="6" 
                sm="12">
                  <cardFeaturedSponsorsSM
                    v-if="show_featured_sponsor"
                    :types_sponsors="featured_sponsor"   
                    class="d-flex justify-center" 
                  />
              </v-col>
            </v-row>
          </v-col>

          <v-col 
            class="d-flex align-center justify-center mt-8"
            cols="12">
            <v-row class="pt-8 ma-8">

              <v-col cols="4" align="center">
                <router-link to="/auditoriums">
                  <v-img
                    max-width="310px"
                    max-height="120px"
                    contain
                    class="link-item button-imagen"
                    :src="auditorium_button">
                  </v-img>
                </router-link>
              </v-col>

              <v-col cols="4" align="center">
                <router-link to="/project-gallery">
                  <v-img 
                    max-width="310px"
                    max-height="120px"
                    contain
                    class="link-item button-imagen"
                    :src="project_gallery_button">
                  </v-img>
                </router-link>
              </v-col>
              
              <v-col cols="4" align="center">
                <router-link to="/program">
                  <v-img 
                    max-width="310px"
                    max-height="120px"
                    contain
                    class="link-item button-imagen"
                    :src="program_button">
                  </v-img>
                </router-link>
              </v-col>
              
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="!loading && !$vuetify.breakpoint.smAndUp">
          <v-col 
            cols="12" 
            xl="6" 
            md="6" 
            sm="12" 
            class="mt-8 d-flex justify-center" >

            <v-img 
              max-width="320px"
              max-height="420px"
              min-height="120px"
              contain
              @click="dialog_edition = true"
              style="cursor: pointer;"
              :src="home_logo">
            </v-img>
          </v-col>
  
          <v-col 
            class="d-flex align-center justify-center mt-8"
            cols="12" 
            xl="6" 
            md="6" 
            sm="12">
            <v-row class="mt-8">

              <v-col cols="12" align="center">
                <v-row>
                  <v-col class="mt-2">
                    <router-link to="/auditoriums">
                      <v-img
                        max-width="280px"
                        max-height="240px"
                        contain
                        class="link-item button-imagen"
                        :src="auditorium_button">
                      </v-img>
                    </router-link>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="mt-2">
                    <router-link to="/project-gallery">
                      <v-img 
                        max-width="280px"
                        max-height="240px"
                        contain
                        class="link-item button-imagen"
                        :src="project_gallery_button">
                      </v-img>
                    </router-link>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="mt-2">
                    <router-link to="/program">
                      <v-img 
                        max-width="280px"
                        max-height="240px"
                        contain
                        class="link-item button-imagen"
                        :src="program_button">
                      </v-img>
                    </router-link>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col
          cols="12" class="mt-4 mb-4">
          <v-row>

            <v-col v-if="featured_sponsor && !$vuetify.breakpoint.smAndUp">
              <cardFeaturedSponsors 
                v-if="show_featured_sponsor"
                :types_sponsors="featured_sponsor" 
                class="d-flex justify-center mt-8 pa-2"
              />
            </v-col>

          </v-row>
        </v-col>

      </v-row>
    </v-sheet>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_edition"
      max-width="560"
      dark>
      <v-card>
        <v-card-title>
          <p>{{ edition.edition.name  }}</p>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-caption mt-4 text">
              {{ edition.edition.description }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="dialog_edition = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
const APP_URL = process.env.VUE_APP_URL
import axios from 'axios'
import { mapGetters } from 'vuex'

import cardFeaturedSponsors from '@/components/card/cardFeaturedSponsors.vue'
import cardFeaturedSponsorsSM from '@/components/card/cardFeaturedSponsorsSM.vue'

export default {
  name: 'homeOne',
  components: {
      cardFeaturedSponsors,
      cardFeaturedSponsorsSM
    },
  data: () => ({
    loading:true,
    show_featured_sponsor: true,
    
    dialog_edition: false,
    
    home_title:'',
    home_title_dark_mode: false,

    home_image:null,
    home_logo:null,

    auditorium_button:null,
    project_gallery_button:null,
    program_button:null,

    featured_sponsor: null
  }),
  computed: {
    ...mapGetters([ 
        'edition'
    ])
  },
  watch: {
    edition: {
      handler(newValue) {
        this.home_title = this.edition.edition.edition_customization.home_title
        this.home_title_dark_mode = this.edition.edition.edition_customization.home_title_dark_mode

        this.home_image = APP_URL + newValue.edition.edition_customization.home_image
        this.home_logo = APP_URL + newValue.edition.edition_customization.home_logo

        this.auditorium_button = APP_URL + newValue.edition.edition_customization.auditorium_button
        this.project_gallery_button = APP_URL + newValue.edition.edition_customization.project_gallery_button
        this.program_button = APP_URL + newValue.edition.edition_customization.program_button

        this.getFeaturedSponsor()
      },
      deep: true
    },
  },

  methods:{
    async getFeaturedSponsor(){
      this.show_featured_sponsor = false
      await axios.get('featured-sponsors/'+this.edition.edition.slug).then((response) =>{
        this.featured_sponsor = response.data.data.featured_sponsor
        this.show_featured_sponsor = true
      }).catch(error => {
        console.log(error);
      })
    },

    async getHome(){
      await axios.get('participant/home/'+this.edition.edition.id).then(() =>{
      }).catch(error => {
        console.log(error);
      })
    },

    setData(){
      this.home_title = this.edition.edition.edition_customization.home_title
      this.home_title_dark_mode = this.edition.edition.edition_customization.home_title_dark_mode
      
      this.home_image = APP_URL + this.edition.edition.edition_customization.home_image
      this.home_logo = APP_URL + this.edition.edition.edition_customization.home_logo

      this.auditorium_button = APP_URL + this.edition.edition.edition_customization.auditorium_button
      this.project_gallery_button = APP_URL + this.edition.edition.edition_customization.project_gallery_button
      this.program_button = APP_URL + this.edition.edition.edition_customization.program_button
    }
  },
  created(){
    Promise.all([
      this.setData(),
      this.getHome(),
      this.getFeaturedSponsor()
    ]).then(() => {
      this.loading=false
    }).catch((error) => {
      console.log(error)
    });
  },
}
</script>
<style scoped>
.image-sheet {
  background-size: cover;
  min-height: 100dvh;
}

.button-imagen {
  cursor: pointer; /* Cambia el cursor al pasar por encima */
  transition: transform 0.2s; /* Agrega una transición suave al efecto */
}

.button-imagen:hover {
  transform: scale(1.03); /* Escala la imagen al 110% del tamaño original en hover */
  /* También puedes añadir otros estilos como sombras, bordes, etc. */
}

.link-item {
  display: block;
  margin-bottom: 10px; /* Adjust as needed */
}

.contenedor-imagenes img {
  display: block; /* Asegura que las imágenes se muestren como bloques */
  margin-bottom: 10px; /* Espacio entre las imágenes (puedes ajustar el valor según tus preferencias) */
}
</style>